import { AppError } from "Errors";

export const isAppError = (error: unknown | AppError): error is AppError =>
  (error as AppError).response.data !== undefined;
